export default __webpack_public_path__ + "static/media/dse8620.b5521b27.webp";